import Head from 'next/head';
import Layout from '@/components/Layout';

export default function about() {
    return (
        <>
            <Layout>
                <Head>
                    <title>About</title>
                </Head>

                <section className="about_section">
                    <div className="container">
                        <div className="text-box-container">
                            <span className="contact-form-title">About Us</span>
                            <p>
                                There's more great Torah content available now than ever before.
                                There's also so many places to search and find the weekly
                                printouts that you want.
                            </p>
                            <p>
                                WhatsApp groups, emails, and websites - where do you go to get
                                your Torah printouts?
                            </p>
                            <p>
                                TorahTable is a central place to find and print all the Torah
                                Printouts that you want. You can find all the latest printouts,
                                search for interesting new PDFs, and even upload your own content
                                for others to enjoy.
                            </p>
                            <p>
                                The site is free to search and download content, making great
                                content easily accessible to thousands of people worldwide.
                            </p>
                            <p>
                                If you would like your content featured on our site, please email{' '}
                                <a className="text-primary" href="mailto:content@torahtable.com">
                                    content@torahtable.com
                                </a>
                            </p>
                            <p>
                                Please note that we will only approve content that is free and
                                open source. Our admin team will flag any content that is
                                copyright by the publisher.
                            </p>
                            <p>
                                Please stay tuned for more features coming soon (social sharing
                                and email digests, and more).
                            </p>
                            <p>
                                For more information or to see how you can get involved, please
                                email{' '}
                                <a className="text-primary" href="mailto:content@torahtable.com">
                                    content@torahtable.com
                                </a>{' '}
                                - we'd love to hear from you.
                            </p>
                            <p>Happy Learning,</p>
                            <p>The Torahtable Team</p>
                        </div>
                    </div>
                </section>

            </Layout>
        </>
    );
}
